import React from "react";
import { NavLink } from "react-router-dom";
import { sidebarTabsByRole } from "../../lib/sidebarTabsConfig";
import { USER_ROLES } from "shared/config/routes";
import styles from "./LkSidebar.module.scss";

export const LkSidebar = ({ role = USER_ROLES.GUEST }) => {
  const tabs = sidebarTabsByRole[role] ?? [];

  if (!tabs.length) return null;

  return (
    <aside className={styles.sidebar}>
      <nav className={styles.sidebar__nav}>
        <ul className={styles.sidebar__list}>
          {tabs.map((tab) => (
            <li key={tab.to} className={styles.sidebar__item}>
              <NavLink
                to={tab.to}
                className={({ isActive }) =>
                  `${styles.sidebar__link} ${isActive ? styles.sidebar__linkActive : ""}`
                }
              >
                {tab.label}
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>
    </aside>
  );
};
